import { memo, useCallback, useState } from 'react';
import { Dialog } from '../Dialog/Dialog';
import { translates } from '../../constants/translates';
import {useChat} from "../../context/Context";

export const LeaveDialogs = memo(({
    evaluationEnabled,
    oneClickCloseEnabled,
    showChatHandler,
    hideChatHandler,
}) => {
    const [isShowEvaluation, setShowEvaluation] = useState(oneClickCloseEnabled && evaluationEnabled);
    const {defaultLang} = useChat();

    const showEvaluation = useCallback(() => {
        setShowEvaluation(true);
    }, []);

    return !isShowEvaluation ? (
        <Dialog
            title={translates[defaultLang].cancel_dialog}
            onCancel={showChatHandler}
            onSend={evaluationEnabled ? showEvaluation : hideChatHandler}
            applyText={translates[defaultLang].close}
            cancelText={translates[defaultLang].cancel}
        />
    ) : (
        <Dialog
            title={translates[defaultLang].complete_askings}
            onCancel={hideChatHandler}
            onSend={hideChatHandler}
            applyText={translates[defaultLang].apply_btn}
            cancelText={translates[defaultLang].cancel_btn}
        />
    );
});
